var map = {
	"./ptBR/consciencia-negra.png": 1126,
	"./ptBR/customer-day.png": 1127,
	"./ptBR/dia-do-professor.png": 1128,
	"./ptBR/dia-dos-finados.png": 1129,
	"./ptBR/farroupilha.png": 1130,
	"./ptBR/natal.png": 1131,
	"./ptBR/nossa-senhora-aparecida.png": 1132,
	"./ptBR/pink-october.png": 1133,
	"./ptBR/proclamacao-da-republica.png": 1134
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1125;